import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  cookieButton: {
    position: 'fixed',
    left: '0px',
    bottom: '20%',
    transform: 'translateX(-50%)',
    zIndex: theme.zIndex.snackbar,
    maxWidth: '48px',
    borderRadius: '50%',
    transitionDuration: '0.5s',
    boxShadow: theme.shadows[4],
    '&:hover': {
      transform: 'translateX(0)',
    },
  },
  paper: {
    position: 'fixed',
    bottom: '0px',
    zIndex: theme.zIndex.snackbar,
    width: '100vw',
    backgroundColor: '#eee',
    padding: '16px 8px',
    '& b': {
      display: 'inline-block',
    },
  },
  bannerContent: {
    maxWidth: '700px',
    margin: 'auto',
  },
  optionalCookies: {
    '& label': {
      width: '100%',
      margin: '0px',
      justifyContent: 'space-between',
    },
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '16px',
  },
  button: {
    flex: '0 1 49%',
  },
  moreButton: {
    backgroundColor: '#F5F5F5',
    color: '#6F7072',
    '&:hover': {
      backgroundColor: '#eee',
    },
  },
}));
